import React, { useEffect } from "react";
import "./VirasatDefaultHomePage.scss"
import VirasatDefaultHeroPage from "./VirasatDefaultHeroPage";
import VirsatDefaultStoryPage from "./VirsatDefaultStoryPage";
import VirasatDefaultServicesPage from "./VirasatDefaultServicesPage";
import VirasatDefaultExpPage from "./VirasatDefaultExpPage";
import VirasatDefaultGalleryPage from "./VirasatDefaultGalleryPage";
import VirasatDefaultResPage from "./VirasatDefaultResPage";
import { useSelector } from "react-redux";
import { sortByOrderAscending } from "../../helper/helper";
import { useHistory } from "react-router";

const VirasatDefaultHomePage = () => {
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "home")
    const Components = page?.Components || []
    const history = useHistory()
    useEffect(() => {
        window.scrollTo(0, 0);
        if (Components.length === 0) {
            history.push("/coming-soon")
        }
    }, []);
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultHeroPage":
                return <VirasatDefaultHeroPage components={component.Components} heroBackground={component?.Props?.bgSrc} />
            case "VirsatDefaultStoryPage":
                return <VirsatDefaultStoryPage components={component.Components} />
            case "VirasatDefaultServicesPage":
                return <VirasatDefaultServicesPage components={component.Components} />
            case "VirasatDefaultExpPage":
                return <VirasatDefaultExpPage components={component.Components} />
            case "VirasatDefaultGalleryPage":
                return <VirasatDefaultGalleryPage components={component.Components} />
            case "VirasatDefaultResPage":
                return <VirasatDefaultResPage components={component.Components} props={component?.Props} />
            default:
                return <div />
        }

    }
    return (
        <div className="VirasatDefaultHomePage" >
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
        </div>
    )
}
export default VirasatDefaultHomePage